import { push } from "react-router-redux";

export function back(id) {
  return (dispatch) => {
    dispatch(push(`/wish/detail/${id}`));
  };
}
